var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1C14.25 0.585786 14.5858 0.25 15 0.25H16C19.1756 0.25 21.75 2.82436 21.75 6V7C21.75 7.41421 21.4142 7.75 21 7.75C20.5858 7.75 20.25 7.41421 20.25 7V6C20.25 3.65279 18.3472 1.75 16 1.75H15C14.5858 1.75 14.25 1.41421 14.25 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6C2.25 2.82436 4.82436 0.25 8 0.25H9C9.41421 0.25 9.75 0.585787 9.75 1C9.75 1.41421 9.41421 1.75 9 1.75H8C5.65279 1.75 3.75 3.65279 3.75 6V7C3.75 7.41421 3.41421 7.75 3 7.75C2.58579 7.75 2.25 7.41421 2.25 7V6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 12C0.25 11.5858 0.585786 11.25 1 11.25H23C23.4142 11.25 23.75 11.5858 23.75 12C23.75 12.4142 23.4142 12.75 23 12.75H21.7073C21.735 12.8282 21.75 12.9123 21.75 13V14C21.75 17.1756 19.1756 19.75 16 19.75H15C14.5858 19.75 14.25 19.4142 14.25 19C14.25 18.5858 14.5858 18.25 15 18.25H16C18.3472 18.25 20.25 16.3472 20.25 14V13C20.25 12.9123 20.265 12.8282 20.2927 12.75H16.8988C16.4812 14.6102 14.8196 16 12.8333 16H11.1667C9.18042 16 7.51878 14.6102 7.10116 12.75H3.70732C3.73496 12.8282 3.75 12.9123 3.75 13V14C3.75 16.3472 5.65279 18.25 8 18.25H9C9.41421 18.25 9.75 18.5858 9.75 19C9.75 19.4142 9.41421 19.75 9 19.75H8C4.82436 19.75 2.25 17.1756 2.25 14V13C2.25 12.9123 2.26504 12.8282 2.29268 12.75H1C0.585786 12.75 0.25 12.4142 0.25 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 4C8.86548 4 7 5.86548 7 8.16667C7 8.6269 7.3731 9 7.83333 9H16.1667C16.6269 9 17 8.6269 17 8.16667C17 5.86548 15.1345 4 12.8333 4H11.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomCheckIn);
export default __webpack_public_path__ + "static/media/random-check-in.564d58b5a944fe797499e84ae9ea2cdc.svg";
export { ForwardRef as ReactComponent };